import * as action_types from "./constants";
import { UsersTableType } from "./types";

export type myTeamState = {
  usersData: {
    loader: boolean;
    data: UsersTableType[] | null;
    count: number;
  };
};

const initialState: myTeamState = {
  usersData: {
    loader: true,
    data: null,
    count: 0,
  },
};

interface ApiPayload {
  data: UsersTableType[];
  count: number;
}

const myTeamReducer = (
  state = initialState,
  action: { type: string; payload: { data: ApiPayload; loading: boolean } }
) => {
  const { type, payload } = action;
  switch (type) {
    case action_types.USER_LISTING:
      return {
        ...state,
        usersData: {
          loader: payload?.loading || false,
          data: payload?.data?.data,
          count: payload?.data?.count,
        },
      };

    default:
      return state;
  }
};

export default myTeamReducer;
